import { ACTION_TYPES } from "src/constants";
import { INITIAL_STATE } from "../store";

export default function LeadNotesReducer(state = INITIAL_STATE.leadNotes, action) {
  switch (action.type) {

    case ACTION_TYPES.REQUEST_CREATE_NOTES_SUCCESS: {
      return [...state, action.payload.leadNotes]
    }

    case ACTION_TYPES.REQUEST_ADMIN_LOGOUT:
    case ACTION_TYPES.ADMIN_LOGOUT_SUCCESS:
      return INITIAL_STATE.leadNotes;

    default:
      return state;
  }
}